export default __webpack_public_path__ + "static/media/corner2.b2e7c19f.png";